import http from "@/services/http";

// Vitrine pública: o tenant vem do slug na URL
export const showcase = () => {
  async function getOne(slug) {
    const {data} = await http.get('/showcase/'+encodeURIComponent(slug));
    return data;
  }

  async function availability(slug, start, end) {
    const {data} = await http.get('/showcase/'+encodeURIComponent(slug)+'/availability', { params: { start, end } });
    return data;
  }

  async function storeOrder(slug, order) {
    const response = await http.post('/showcase/'+encodeURIComponent(slug)+'/orders', order);
    return response.data;
  }

  async function freight(slug, params) {
    const {data} = await http.get('/showcase/'+encodeURIComponent(slug)+'/freight', { params });
    return data;
  }

  return {getOne, availability, storeOrder, freight};
}
